import qs from 'qs';
import { trackPromise } from 'react-promise-tracker';
import api from '../../../../../utils/API';

const URL = process.env.REACT_APP_IPA_PRICE_TABLES_MANAGER_URL;

// ########## - EDITAR TABELA BASE - ##########

export const getEditBaseTableListService = data =>
  trackPromise(
    api({
      url: `${URL}/rascunho-produto-base/by-uf/${data.uf}`,
      method: 'POST',
      expectToken: true,
      params: {
        page: data.page,
        size: data.size,
      },
      data: {
        descricao: data.descricao || [],
        familia: data.familia || [],
        tier: data.tier || [],
      },
    }).then(res => res),
    'table-edit-base',
  );

export const getHeaderUpdateTimeViewService = () =>
  trackPromise(
    api({
      url: `${URL}/tabela-base/NACIONAL`,
      method: 'GET',
      expectToken: true,
    }).then(res => res),
  );

export const selectAllAplicarPrecos = (uf: string) =>
  trackPromise(
    api({
      url: `${URL}/tabela-base/aplicar-precos/${uf}`,
      method: 'PUT',
      expectToken: true,
    }).then(res => res),
    'table-edit-base',
  );

export const saveCustoFabricacao = data =>
  trackPromise(
    api({
      url: `${URL}/rascunho-produto-base/preco`,
      method: 'PUT',
      expectToken: true,
      data,
    }).then(res => res),
  );

export const priceApply = params =>
  trackPromise(
    api({
      url: `${URL}/rascunho-produto-base/aplicar-precos`,
      method: 'PUT',
      expectToken: true,
      params: {
        idsRascunhoProduto: params,
      },
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    }).then(res => res),
    'table-edit-base',
  );

export const saveCustosProduto = data =>
  trackPromise(
    api({
      url: `${URL}/rascunho-produto-base/custo`,
      method: 'PUT',
      expectToken: true,
      data,
    }).then(res => res),
  );

export const saveCustosGeraisTabela = data =>
  trackPromise(
    api({
      url: `${URL}/custos-gerais-tabela`,
      method: 'POST',
      expectToken: true,
      data,
    }).then(res => res),
  );

export const getCustosGeraisTabela = (uf: string) =>
  trackPromise(
    api({
      url: `${URL}/custos-gerais-tabela/${uf}`,
      method: 'GET',
      expectToken: true,
    }).then(res => res),
    'custos-gerais-tabela',
  );

export const getBaseTableBigNumbers = data =>
  trackPromise(
    api({
      url: `${URL}/tabela-base/big-numbers`,
      method: 'POST',
      expectToken: true,
      params: {
        idTabelaBase: data.id,
      },
      data: {
        descricao: data.descricao,
        familia: data.familia,
        tier: data.tier,
      },
    }).then(res => res),
    'table-edit-base',
  );
